import React from 'react';
import cn from "classnames";
import styles from './videoSection.module.css'
import {VideoSectionProps} from "../../utils/PropsTypes";


const VideoSection: React.FC<VideoSectionProps> = ({ title, children }) => {
    return (
        <section className={cn('section', styles.section)}>
            <div className={styles.videoContainer}>
                <div className={'main-video-container'}>
                    {children}
                </div>
                <p className={styles.videoDescription}>
                    {title}
                </p>
            </div>
        </section>
    );
};

export default VideoSection;